import { Injectable, Injector } from '@angular/core';
import { BaseModelService } from '../base.model.service';
import TemplateModel from 'src/app/models/templates/template.model';
import { Observable } from 'rxjs';
import { flatMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TemplateModelService extends BaseModelService<TemplateModel> {
  constructor(protected injector: Injector) {
    super(injector);
  }
  protected get controllerName(): string {
    return 'Template';
  }

  public updateMany(model: TemplateModel[]): Observable<TemplateModel[]> {
    return this.configService.loadConfig().pipe(
      flatMap((config) => {
        return this.http.put<TemplateModel[]>(
          `${config.apiURL}/${this.controllerName}/UpdateMany`,
          model
        );
      })
    );
  }
}
